module.exports = __webpack_public_path__ + "img/MES2Indice6.ac25684a.png";